export default __webpack_public_path__ + "static/media/cloneBold.6f710a27.jpg";